import * as React from 'react'
import * as Styles from './HomeRankingModule.style'
import {renderPopular, mta} from '@/utils/tools'
import {classes, style} from 'typestyle'
import globalBus from '@/services/Bus'
import {useGlobalBus} from '@/services/global-bus'
import {ImageView} from '../ImageView/ImageView'
import { replaceWkDomain } from '../../../../utils/tools'

interface IplayInfoType {
    status: string,
    operationID: string
}

declare const window: any

const ImageConfig = {
    0: require('./assets/images/排行榜_0.png'),
    1: require('./assets/images/排行榜_1.png'),
    2: require('./assets/images/排行榜_2.png')
}

export function HomeRankingModule(props) {
    const content = props.data.contents
    const title = props.data.name
    const [playInfo, setPlayInfo] = React.useState<IplayInfoType>({status: 'PAUSE', operationID: '0'})

    const operationAudio = (info, e, type) => {
        e.stopPropagation()
        mta(`main-listen-btn-click'}`)
        if (Number(playInfo.operationID) === info.content_id) { // 暂停

            if (type === 'pause') {
                globalBus.emit({
                    audioPlayerStatusChange: {
                        status: 'PAUSE',
                        operationID: info.content_id
                   }
               })
            } else {
                globalBus.emit({
                    audioPlayerStatusChange: {
                        status: 'PLAY',
                        operationID: info.content_id
                   }
               })
            }
            return
        }
        globalBus.emit({
            playerInfo: {
                lecture_url: info.url,
                url: info.listen_url,
                cover: info.cover,
                playId: info.content_id
            }
        })
    }

    useGlobalBus({
        audioPlayerStatusChange: (info) => {
            setPlayInfo(info)
        }
    })

    const renderPlayStatus = (id: number, details: any) => {
        if (playInfo.status === 'PLAY' && Number(playInfo.operationID) === id) {
            return (
                <div className={Styles.playBtn} onClick={(e) => operationAudio(details, e, 'pause')}>
                    <img src="https://static-cos.lycheer.net/picture/10490565_44a2dd6af77033cf8a7f851be4094028.jpg" alt=""/>
                    <i>暂停</i>
                </div>
            )
        } else {
            return (
            <div className={Styles.playBtn} onClick={(e) => operationAudio(details, e, 'play')}>
                 <img src="https://static-cos.lycheer.net/picture/10490565_b7c94067627a5f97f2b0a14a4d8e05be.jpg" alt=""/>
                 <i>试听</i>
            </div>
            )
        }
    }

    if (content.length > 0) {
        return (
            <div className="HomeRanking">
                <div className={Styles.title}>{title}</div>
                <div className={Styles.HomeRankingModule}>

                    {content.length > 0 &&
                    <div className={Styles.HomeRankingContentWrap} key={content[0].content_id} onClick={() => {
                        location.assign(replaceWkDomain(content[0].url))
                    }}>
                    <div className={Styles.HomeRankingContentLeft}>

                            <div className={Styles.HomeRankingCover}>
                                <div className={Styles.Imagewrap}>
                                    <ImageView url={content[0].cover}/>
                                </div>
                                <img className={Styles.RankCoverTag} src={ImageConfig[0]} alt=""/>
                            </div>
                    </div>

                    <div className={Styles.HomeRankingContentRight}>
                            <div><p className={classes(Styles.HomeRankingContentRightTitle, 'TextChangeToTwoLines')}>{content[0].title}</p></div>

                            <div className={Styles.HomeRankingContentButton}>
                                <div className={Styles.popularNum}>
                                    <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                                    <p>{renderPopular(content[0].popular)}人</p>
                                </div>
                                {content[0].can_listen ? (
                                <div className={Styles.listenBtn}>
                                    {renderPlayStatus(content[0].content_id, content[0])}
                                </div>) : ''}
                            </div>
                    </div>
                    </div>}

                    {content.length > 2 &&
                    <div className={Styles.noramlRankList}>

                        {content.slice(1).map((item, index) => (
                            <div className={Styles.HomeRankingContentWrapNormal} key={item.content_id} onClick={() => location.assign(item.url)}>
                                <div className={Styles.HomeRankingContentTop}>
                                    <div className={Styles.HomeRankingCoverNormal}>
                                    <div className={Styles.Imagewrap}>
                                        <ImageView url={item.cover}/>
                                    </div>
                                        {index + 1 <= 2 && <img className={Styles.RankCoverTagNormal} src={ImageConfig[index + 1]} alt=""/>}
                                    </div>
                                </div>

                                <div className={Styles.HomeRankingContentBottom}>
                                    <div><p className={classes(Styles.HomeRankingContentRightTitle, 'TextChangeToTwoLines')}>{item.title}</p></div>

                                    <div className={Styles.HomeRankingContentButton}>
                                        <div className={Styles.popularNum}>
                                            <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                                            <p>{renderPopular(item.popular)}人</p>
                                        </div>
                                        {item.can_listen ? (
                                        <div className={Styles.listenBtn}>
                                            {renderPlayStatus(item.content_id, item)}
                                        </div>) : ''}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>}
                </div>
            </div>
        )
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeRankingModule/HomeRankingModule.tsx